<template>
  <div :class="classObj" class="app-wrapper">
    <div
      v-if="device === 'mobile' && sidebar.opened"
      class="drawer-bg"
      @click="handleClickOutside"
    />
    <sidebar class="sidebar-container" />
    <div :class="{ hasTagsView: needTagsView }" class="main-container">
      <div :class="{ 'fixed-header': fixedHeader }">
        <navbar />
        <tags-view v-if="needTagsView" />
      </div>
      <app-main />
      <!--      <right-panel v-if="showSettings">-->
      <!--        <settings />-->
      <!--      </right-panel>-->
    </div>
  </div>
</template>

<script>
import { AppMain, Navbar, Sidebar, TagsView } from "./components";
import ResizeMixin from "./mixin/ResizeHandler";
import { mapState } from "vuex";
import { getToken } from "@/utils/auth";
import { timeTaskToken } from "@/api/article";
import Cookies from "js-cookie";

export default {
  name: "Layout",
  components: {
    AppMain,
    Navbar,
    Sidebar,
    TagsView,
  },
  mixins: [ResizeMixin],
  computed: {
    ...mapState({
      sidebar: (state) => state.app.sidebar,
      device: (state) => state.app.device,
      showSettings: (state) => state.settings.showSettings,
      needTagsView: (state) => state.settings.tagsView,
      fixedHeader: (state) => state.settings.fixedHeader,
    }),
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === "mobile",
      };
    },
  },
  created() {
    this.$store.dispatch("app/getMb");
    this.$store.dispatch("user/getInfo");
    this.init();
    this.getTimeTaskTokenData();
  },
  mounted() {
    let list = JSON.parse(sessionStorage.getItem("menuList") || "[]");
    console.log(list, "333333");
    if (list.length == 0) {
      this.$message({
        type: "error",
        message: "请联系业务管理员授权后，再次登陆。将在3秒后自动退出",
        offset: 300,
        duration: 3000,
        onClose: () => {
          this.$store.dispatch("user/logout").then(() => {
            this.$router.replace("/login");
            location.reload();
          });
        },
      });
    }
  },
  methods: {
    getTimeTaskTokenData() {
      timeTaskToken().then((res) => {
        Cookies.set("xxljob_adminlte_settings", "on");
        Cookies.set(
          `${res.data.headerValue.split(";")[0].split("=")[0]}`,
          res.data.headerValue.split(";")[0].split("=")[1]
        );
      });
    },
    handleClickOutside() {
      this.$store.dispatch("app/closeSideBar", { withoutAnimation: false });
    },
    init() {
      let that = this;
      let token = getToken();
      if (!window.WebSocket) {
        window.WebSocket = window.MozWebSocket;
        return;
      }
      this.$socket = new WebSocket(
        process.env.NODE_ENV == "development"
          ? `wss://${window.location.host}/dtwss/ws?token=${token}`
          : `wss://${window.location.host}/dtwss/ws?token=${token}`
      );
      this.$socket.onmessage = (res) => {
        let data = JSON.parse(res.data);
        this.$bus.$emit("updateIndexTodoCount", data);
        console.log("onmessage", res);
      };
      this.$socket.onopen = (res) => {
        heartCheck.start();
        console.log("onopen", res);
      };
      this.$socket.onclose = (res) => {
        // heartCheck.stop();
        clearInterval(heartCheck.timeoutObj);
        reconnect();
        console.log("onclose", res);
      };
      this.$socket.onerror = (res) => {
        console.log("onerror", res);
        // reconnect()
      };

      //重试连接socket
      function reconnect() {
        that.$socket = new WebSocket(
          process.env.NODE_ENV == "development"
            ? `wss://demo.youuq.cn/dtwss/ws?token=${token}`
            : `wss://${window.location.host}/dtwss/ws?token=${token}`
        );
      }

      var heartCheck = {
        timeout: 30000,
        timeoutObj: null,
        start: function () {
          console.log(getNowTime() + " Socket 心跳检测");
          this.timeoutObj && clearInterval(this.timeoutObj);
          this.timeoutObj = setInterval(function () {
            //这里发送一个心跳，后端收到后，返回一个心跳消息，
            //onmessage拿到返回的心跳就说明连接正常
            console.log(getNowTime() + " Socket 心跳发送");
            that.$socket.send("连接成功");
          }, this.timeout);
        },
        stop: function () {
          this.timeoutObj && clearInterval(this.timeoutObj);
        },
      };

      function p(s) {
        return s < 10 ? "0" + s : s;
      }

      function getNowTime() {
        var myDate = new Date();
        //获取当前年
        var year = myDate.getFullYear();
        //获取当前月
        var month = myDate.getMonth() + 1;
        //获取当前日
        var date = myDate.getDate();
        var h = myDate.getHours(); //获取当前小时数(0-23)
        var m = myDate.getMinutes(); //获取当前分钟数(0-59)
        var s = myDate.getSeconds();
        return (
          year +
          "-" +
          p(month) +
          "-" +
          p(date) +
          " " +
          p(h) +
          ":" +
          p(m) +
          ":" +
          p(s)
        );
      }
    },
  },
};
</script>
<!--suppress CssUnknownTarget -->
<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  width: calc(100% - #{$sideBarWidth});
  transition: width 0.28s;
}

.hideSidebar .fixed-header {
  width: calc(100% - 54px);
}

.mobile .fixed-header {
  width: 100%;
}

.main-container {
  min-height: 361px;
  min-width: 1277px;
}
</style>
